
define('template!portalUsersRoutingTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="sections-card">\n  <div class="sections-card__title">\n    ' +
((__t = ( _.i18n('portalUsers.sections.label', null, 'What this supplier can open in the portal') )) == null ? '' : __t) +
'\n  </div>\n\n  <div class="sections-card__row">\n    <label class="routing-switch">\n      <input type="checkbox" class="checkbox-input js-section" data-key="orders" ' +
((__t = ( orders ? 'checked' : '' )) == null ? '' : __t) +
' >\n      <span class="routing-switch__label">' +
((__t = ( _.i18n('portalUsers.sections.orders', null, 'Orders') )) == null ? '' : __t) +
'</span>\n    </label>\n    <label class="routing-switch">\n      <input type="checkbox" class="checkbox-input js-section" data-key="products" ' +
((__t = ( products ? 'checked' : '' )) == null ? '' : __t) +
' >\n      <span class="routing-switch__label">' +
((__t = ( _.i18n('portalUsers.sections.products', null, 'Products') )) == null ? '' : __t) +
'</span>\n    </label>\n    <label class="routing-switch">\n      <input type="checkbox" class="checkbox-input js-section" data-key="team" ' +
((__t = ( team ? 'checked' : '' )) == null ? '' : __t) +
' >\n      <span class="routing-switch__label">' +
((__t = ( _.i18n('portalUsers.sections.team', null, 'Accounts') )) == null ? '' : __t) +
'</span>\n    </label>\n  </div>\n\n  <p class="sections-card__hint">\n    ' +
((__t = ( _.i18n('portalUsers.sections.hint', null,
      'A section that is off is hidden in the portal, and refused if asked for directly. Orders being on does not send them here — that is the switch below.') )) == null ? '' : __t) +
'\n  </p>\n\n  ';
 if (!orders && !products && !team) { ;
__p += '\n    <p class="sections-card__warning">\n      ' +
((__t = ( _.i18n('portalUsers.sections.none', null,
        'With all three off, this supplier can sign in but has nothing to open.') )) == null ? '' : __t) +
'\n    </p>\n  ';
 } ;
__p += '\n\n  <p class="routing-card__error js-sections-error"></p>\n</div>\n\n<div class="routing-card ' +
((__t = ( usePortal ? 'is-on' : 'is-off' )) == null ? '' : __t) +
'">\n  <label class="routing-switch">\n    <input type="checkbox" class="checkbox-input js-toggle" ' +
((__t = ( usePortal ? 'checked' : '' )) == null ? '' : __t) +
'>\n    <span class="routing-switch__label">' +
((__t = ( _.i18n('portalUsers.routing.label', null,
      'Send this supplier\'s orders to the portal') )) == null ? '' : __t) +
'</span>\n  </label>\n\n  <p class="routing-card__state">\n    ';
 if (usePortal) { ;
__p += '\n      ' +
((__t = ( _.i18n('portalUsers.routing.on', null,
        'Orders show a "Send order to supplier" tab, and land in this supplier\'s portal queue.') )) == null ? '' : __t) +
'\n    ';
 } else { ;
__p += '\n      ' +
((__t = ( _.i18n('portalUsers.routing.off', null,
        'Orders for this supplier are not sent to the portal. Accounts below still work, but the queue stays empty.') )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n  </p>\n\n  ';
 if (hasApiConnector && usePortal) { ;
__p += '\n    <p class="routing-card__warning">\n      ' +
((__t = ( _.i18n('portalUsers.routing.apiBypassed', null,
        'This supplier also has API credentials. While the portal is on, their orders go to the portal instead of their API. The credentials are kept.') )) == null ? '' : __t) +
'\n    </p>\n  ';
 } else if (hasApiConnector) { ;
__p += '\n    <p class="routing-card__note">\n      ' +
((__t = ( _.i18n('portalUsers.routing.apiInUse', null,
        'This supplier has API credentials, so their orders go straight to their own system.') )) == null ? '' : __t) +
'\n    </p>\n  ';
 } ;
__p += '\n\n  <p class="routing-card__error js-error"></p>\n</div>\n\n<div class="statuses-card">\n  <div class="statuses-card__title">\n    ' +
((__t = ( _.i18n('portalUsers.statuses.label', null, 'Where the order goes in Compuzz when the supplier acts') )) == null ? '' : __t) +
'\n  </div>\n\n  <div class="statuses-card__row">\n    <div class="form-group statuses-card__field">\n      <label for="portal-status-accepted">' +
((__t = ( _.i18n('portalUsers.statuses.accepted', null, 'Order accepted') )) == null ? '' : __t) +
'</label>\n      <select id="portal-status-accepted" class="form-control js-status" data-key="acceptedStatus">\n        <option value="">' +
((__t = ( _.i18n('portalUsers.statuses.unchanged', null, '— leave the order where it is —') )) == null ? '' : __t) +
'</option>\n      </select>\n    </div>\n    <div class="form-group statuses-card__field">\n      <label for="portal-status-shipped">' +
((__t = ( _.i18n('portalUsers.statuses.shipped', null, 'Order shipped') )) == null ? '' : __t) +
'</label>\n      <select id="portal-status-shipped" class="form-control js-status" data-key="shippedStatus">\n        <option value="">' +
((__t = ( _.i18n('portalUsers.statuses.unchanged', null, '— leave the order where it is —') )) == null ? '' : __t) +
'</option>\n      </select>\n    </div>\n  </div>\n\n  <p class="statuses-card__hint">\n    ' +
((__t = ( _.i18n('portalUsers.statuses.hint', null,
      'The Compuzz order takes this status the moment the supplier accepts, or ships, in the portal. The support team is notified either way.') )) == null ? '' : __t) +
'\n  </p>\n\n  <p class="routing-card__error js-statuses-error"></p>\n</div>\n\n<div class="labels-card">\n  <label class="routing-switch">\n    <input type="checkbox" class="checkbox-input js-allow-labels" ' +
((__t = ( allowLabels ? 'checked' : '' )) == null ? '' : __t) +
'>\n    <span class="routing-switch__label">' +
((__t = ( _.i18n('portalUsers.labels.label', null,
      'Let this supplier buy shipping labels on our Sendcloud account') )) == null ? '' : __t) +
'</span>\n  </label>\n\n  ';
 if (!sendcloudConfigured) { ;
__p += '\n    <p class="labels-card__warning">\n      ' +
((__t = ( _.i18n('portalUsers.labels.notConfigured', null,
        'No Sendcloud keys on this account yet, so no label can be bought. Add them before turning this on.') )) == null ? '' : __t) +
'\n    </p>\n  ';
 } ;
__p += '\n\n  ';
 if (allowLabels) { ;
__p += '\n    <div class="labels-card__fields">\n      <div class="form-group">\n        <label for="sendcloud-sender">' +
((__t = ( _.i18n('portalUsers.labels.senderAddress', null,
          'Sendcloud sender address id') )) == null ? '' : __t) +
'</label>\n        <input id="sendcloud-sender" type="number" class="form-control js-sender-address"\n               value="' +
((__t = ( senderAddressId === null ? '' : senderAddressId )) == null ? '' : __t) +
'">\n        <p class="labels-card__hint">' +
((__t = ( _.i18n('portalUsers.labels.senderAddressHint', null,
          'The supplier\'s own warehouse in Sendcloud. Parcels leave from there, so returns and pickups reach them.') )) == null ? '' : __t) +
'</p>\n      </div>\n      <div class="form-group">\n        <label for="sendcloud-method">' +
((__t = ( _.i18n('portalUsers.labels.shippingMethod', null,
          'Sendcloud shipping method id') )) == null ? '' : __t) +
'</label>\n        <input id="sendcloud-method" type="number" class="form-control js-shipping-method"\n               value="' +
((__t = ( shippingMethodId === null ? '' : shippingMethodId )) == null ? '' : __t) +
'">\n        <p class="labels-card__hint">' +
((__t = ( _.i18n('portalUsers.labels.shippingMethodHint', null,
          'Used for every parcel of this supplier. A parcel too heavy or bound somewhere this method does not serve will be refused by Sendcloud.') )) == null ? '' : __t) +
'</p>\n      </div>\n      <button type="button" class="btn js-save-labels">' +
((__t = ( _.i18n('common.save', null, 'Save') )) == null ? '' : __t) +
'</button>\n      <span class="labels-card__saved js-saved"></span>\n    </div>\n  ';
 } ;
__p += '\n\n  <p class="routing-card__error js-labels-error"></p>\n</div>\n';

}
return __p
};});

